var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"arrow-container"},[_c('p',{staticClass:"m-0",domProps:{"innerHTML":_vm._s(_vm.service)}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"arrow-button",attrs:{"data-state":""}},[_c('i'),_c('i'),_c('i')])
}]

export { render, staticRenderFns }